var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import NavSection from "./NavSection";
import { SetupSections } from "../../constants/stepConfig";
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getStepsAndCount = function (section) {
            var _a = _this.props, customiseSteps = _a.customiseSteps, communicateSteps = _a.communicateSteps, inviteSteps = _a.inviteSteps;
            switch (section) {
                case SetupSections.CUSTOMISE:
                    return { steps: customiseSteps, startingStepCount: 1 };
                case SetupSections.COMMUNICATE:
                    return { steps: communicateSteps, startingStepCount: customiseSteps.length + 1 };
                case SetupSections.INVITE:
                    return { steps: inviteSteps, startingStepCount: communicateSteps.length + customiseSteps.length + 1 };
            }
        };
        return _this;
    }
    Navigation.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(NavSection, __assign({ title: "setup_tenant.navigation.section.title.customise" }, this.getStepsAndCount(SetupSections.CUSTOMISE))),
            React.createElement(NavSection, __assign({ title: "setup_tenant.navigation.section.title.communicate" }, this.getStepsAndCount(SetupSections.COMMUNICATE))),
            React.createElement(NavSection, __assign({ title: "setup_tenant.navigation.section.title.invite" }, this.getStepsAndCount(SetupSections.INVITE)))));
    };
    return Navigation;
}(PureComponent));
export default Navigation;
